import { axios } from "../../helpers/axios";
import { isAuth } from "../../helpers/cookies";
import {
    CHANGE_PASSWORD_URL,
    COMPANY_URL,
    FORGOT_PASSWORD_REQUEST_URL,
    GET_COMPANY_DETAILS,
    GET_USERS_URL,
    GET_USERS_REP_DROPDOWN_URL,
    PROCESS_URL,
    REGISTER_URL,
    RESET_PASSWORD_URL,
    STAGE_URL
} from "./userConstants";

export const api_get_users_rep_dropdown = async () => {
    return axios.get(GET_USERS_REP_DROPDOWN_URL);
};

export const api_forgot_password_request_url = async (data) => {
    return axios.post(FORGOT_PASSWORD_REQUEST_URL, data);
};

export const api_reset_password_url = async (data) => {
    return axios.post(RESET_PASSWORD_URL, data);
};

export const api_change_password_url = async (data) => {
    return axios.post(CHANGE_PASSWORD_URL, data);
};

export const api_register_url = async (data) => {
    return axios.post(REGISTER_URL, data);
};

export const api_get_user_company_url = async (user_id) => {
    const id = user_id || isAuth()?.user_id;
    if (!id) {
        console.warn('api_get_user_company_url: No user_id available');
        return Promise.reject('No user_id');
    }
    return axios.get(`user/${id}/company`);
};

export const api_get_company_process_url = async (company_id) => {
    const id = company_id || isAuth()?.company_id;
    if (!id) {
        console.warn('api_get_company_process_url: No company_id available');
        return Promise.reject('No company_id');
    }
    const url = `company/${id}/process`;
    return axios.get(url);
};

export const api_get_company_process_stage_url = async (payload) => {
    const company_id = payload?.company_id || isAuth()?.company_id;
    const process_id = payload?.process_id;
    if (!company_id || !process_id) {
        console.warn('api_get_company_process_stage_url: Missing IDs', { company_id, process_id });
        return Promise.reject('Missing IDs');
    }
    const url = `company/${company_id}/process/${process_id}/stage`;
    return axios.get(url);
};

export const api_get_company_details_by_domain_url = async (hostname) => {
    const url = `company/${hostname}${GET_COMPANY_DETAILS}`;
    return axios.get(url);
};

export const api_get_users = async () => {
    return axios.get(GET_USERS_URL);
};
